module.exports = __webpack_public_path__ + "img/forward-rounded-dark-blue.be1b32b.svg";